import { component } from "picoapp";

export default component(async (node) => {
  const [
    { default: KeenSlider },
    { useFilter, useUnveil, useNav, useAriaHidden },
  ] = await Promise.all([
    import("keen-slider"),
    import("../lib/keen-slider"),
    import("keen-slider/keen-slider.min.css"),
  ]);

  const sliderContainer = node.querySelector("[data-slider]");
  const sliderElement = sliderContainer.querySelector("[data-keen-slider]");
  const sliderPrevElement = sliderContainer.querySelector("[data-prev]");
  const sliderNextElement = sliderContainer.querySelector("[data-next]");
  const productHandle = node.dataset.carouselProductHandle;
  const preselectedId = node.dataset.carouselPreselectedId;

  const slider = KeenSlider(
    sliderElement,
    {
      defaultAnimation: {
        duration: 800,
      },
      loop: true,
      created: (instance) => {
        if (sliderPrevElement && sliderNextElement) initNavigation(instance);
      },

      animationStarted: () => {
        handleSlideMtrEvent();
      },

      useFilter: {
        dataAttribute: "data-slide-id",
        value: preselectedId,
      },

      useUnveil: {
        dataLazyImageSrc: "data-lazy-src",
        dataLazyImageSrcset: "data-lazy-srcset",
        dataLazyPoster: "data-lazy-poster",
        videoAutoPlay: true,
      },
    },
    [useFilter, useUnveil, useAriaHidden]
  );

  const thumbnailsContainer = node.querySelector("[data-thumbnails]");
  let thumbnailsSlider = null;

  if (thumbnailsContainer) {
    const thumbnailsElement =
      thumbnailsContainer.querySelector("[data-keen-slider]");
    thumbnailsSlider = KeenSlider(
      thumbnailsElement,
      {
        loop: false,
        drag: false,
        defaultAnimation: false,
        slides: {
          origin: 0,
          number: slider.slides.length,
          perView: slider.slides.length,
        },
        vertical: true,
        useFilter: {
          dataAttribute: "data-slide-id",
          value: preselectedId,
        },
        created: (instance) => {
          instance.container.classList.remove("hide-init");
        },
      },
      [useFilter, useNav(slider)]
    );
  }

  function selectVariant(event, productHandle, slider) {
    const product = event.detail.product;
    const variant = event.detail.variant;
    if (
      productHandle !== product ||
      (productHandle === product && slider.options.useFilter.value === variant)
    )
      return;
    updateSlider(slider, event.detail.variant);
    if (thumbnailsSlider) {
      updateThumbnails(thumbnailsSlider, event.detail.variant);
    }
  }

  function updateSlider(slider, variantId) {
    slider.options.useFilter.value = variantId;
    slider.emit("filter");
  }

  function updateThumbnails(slider, variantId) {
    thumbnailsSlider.options.useFilter.value = variantId;
    thumbnailsSlider.options.slides.number = slider.slides.length;
    thumbnailsSlider.options.slides.perView = slider.slides.length;
    thumbnailsSlider.emit("filter");
  }

  function initNavigation(slider) {
    sliderPrevElement.addEventListener("click", () => {
      slider.prev();
    });

    sliderNextElement.addEventListener("click", () => {
      slider.next();
    });
  }

  function handleSlideMtrEvent() {
    const slideIndex = slider.track.absToRel(slider.track.details.abs);
    const slide = slider.slides[slideIndex];
    const rawData = slide.getAttribute("data-mtr-data") ?? "{}";

    try {
      const data = JSON.parse(rawData);
      window.maestro.fireTrackEvent(slide.dataset.mtrAs, data);
    } catch (e) {
      console.error("Could not parse [data-mtr-data] value");
    }
  }

  window.addEventListener("variant-selected:id", (event) =>
    selectVariant(event, productHandle, slider)
  );
  window.dispatchEvent(new Event("product-carousel:mounted"));
});
